var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Cross",

    getDefaultProps () {
        return {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"],[\"http://www.w3.org/2000/svg\",\"sketch\",\"http://www.bohemiancoding.com/sketch/ns\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon-cross-white</title>
  <desc>Created with bin/sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSPage&quot;]]">
    <g id="16.-Event-add-content" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSArtboardGroup&quot;]]" transform="translate(-888.000000, -567.000000)" stroke="currentColor" fill="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <g id="Bitmap-+-upload-+-image-library" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSLayerGroup&quot;]]" transform="translate(330.000000, 323.000000)">
        <g id="upload-+-image-library" transform="translate(32.000000, 0.000000)" data-svgreactloader="[[&quot;http://www.bohemiancoding.com/sketch/ns&quot;,&quot;type&quot;,&quot;MSShapeGroup&quot;]]">
          <g id="upload" transform="translate(0.000000, 225.000000)">
            <g id="editing-menu">
              <g id="buttons" transform="translate(441.000000, 0.000000)">
                <path d="M87.1815213,34.2838121 L86.0905566,33.1928473 L91.9090353,27.3743687 L86.0905566,21.55589 L87.1815213,20.4649253 L93,26.2834039 L98.8184787,20.4649253 L99.9094434,21.55589 L94.0909647,27.3743687 L99.9094434,33.1928473 L98.8184787,34.2838121 L93,28.4653334 L87.1815213,34.2838121 Z" id="icon-cross-white"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/cross.svg
 **/